import { useNavigate, useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
import Dialog from '../../organisms/Dialog';
import PropertyForm from './shared/PropertyForm';
import usePropertyPageForm from '../../../hooks/usePropertyPageForm';

interface PropertyListContext {
    refresh: () => void;
}

const PropertyAssetPageForm = () => {
    const navigate = useNavigate();
    const context = useOutletContext<PropertyListContext>();

    const handleClose = () => navigate('/collateral/properties');

    const handleSuccess = () => {
        toast.success('Imóvel cadastrado com sucesso');
        context?.refresh();
        handleClose();
    };

    const form = usePropertyPageForm({ onClose: handleClose, onCreated: handleSuccess });

    return (
        <Dialog
            id="property-asset-form"
            show={true}
            onClose={handleClose}
            header="Novo Imóvel"
            size="lg"
            body={<PropertyForm {...form} />}
            footer={
                <div className="flex gap-2">
                    <button onClick={handleClose} disabled={form.isCreating}
                        className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 text-sm disabled:opacity-50">
                        Cancelar
                    </button>
                    <button onClick={form.handleCreate} disabled={form.isCreating}
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm disabled:opacity-50">
                        {form.isCreating ? 'Salvando...' : 'Cadastrar'}
                    </button>
                </div>
            }
        />
    );
};

export default PropertyAssetPageForm;
